// Shared Tailwind class constants for legacy form / section typography utilities
// (formerly .section-title, .form-title, .form-background, .form-item-pd,
// .report-section from redesign.css, plus .add-form .card .title from
// global-styles.css).

export const sectionTitleClasses =
    "text-section-title font-serif text-content";

export const formTitleClasses =
    "text-xl font-semibold text-content font-['Open_Sans',serif]";

// Section heading wrapper used inside profile/form cards. Sets the wrapper to
// 32px so the inner heading inherits at 1.5em (matches the old .add-form .card
// .title behavior).
export const cardTitleClasses = 'text-[calc(var(--spacing)*8)] mb-10';

// Step cards sit flush on the Ivory page surface; white is reserved for inputs.
export const formBackgroundClasses = 'bg-surface mx-0!';

export const formItemPdClasses = '[padding:10px_24px]';

export const medicalProviderHeadingClasses = 'text-xl font-bold text-content font-sans!';

// Section heading variant: same typography plus the standard section bottom margin.
export const medicalProviderSectionHeadingClasses = `mb-6! ${medicalProviderHeadingClasses}`;

export const providerRowHeaderClasses = 'flex justify-between items-center mb-2';

// Stone rows, per the Arches Liability step; the old mint was a blue-brand leftover.
export const reportSectionClasses =
    'rounded-lg bg-surface-alt min-h-18 border-0 relative overflow-hidden ' +
    '[&_input[type=file]]:absolute [&_input[type=file]]:opacity-0 ' +
    '[&_input[type=file]]:right-0 [&_input[type=file]]:top-0 ' +
    '[&_input[type=file]]:h-full [&_input[type=file]]:w-full ' +
    '[&_input[type=file]]:cursor-pointer';

export const discoverySectionClasses =
    'rounded-lg border-0 relative overflow-hidden ' +
    '[&_input[type=file]]:absolute [&_input[type=file]]:opacity-0 ' +
    '[&_input[type=file]]:right-0 [&_input[type=file]]:top-0 ' +
    '[&_input[type=file]]:h-full [&_input[type=file]]:w-full ' +
    '[&_input[type=file]]:cursor-pointer';
